import { GoogleScheduleEventResourceMode, GoogleScheduleEventVisibility } from "../../../../../../models/CoreScheduleSyncGoogleModels";


export const resourceModeOptions: GoogleScheduleEventResourceMode[] = [
    GoogleScheduleEventResourceMode.Strict,
    GoogleScheduleEventResourceMode.Permissive,
    GoogleScheduleEventResourceMode.NoResources
];


export const eventVisibilityOptions: GoogleScheduleEventVisibility[] = [
    GoogleScheduleEventVisibility.Default,
    GoogleScheduleEventVisibility.Public,
    GoogleScheduleEventVisibility.Private
];
